import { render, staticRenderFns } from "./PortfolioDashboard.vue?vue&type=template&id=12801749&"
import script from "./PortfolioDashboard.vue?vue&type=script&lang=js&"
export * from "./PortfolioDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports